"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openModal = exports.closeModal = exports.ModalType = exports.InteractionsActionType = void 0;

var _fluxActions = require("flux-actions");

var _actions = require("settings-ui-sdk/utils/actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var InteractionsActionType = (0, _namespacedKeyMirror.default)({
  CLOSE_MODAL: null,
  OPEN_MODAL: null
}, 'esp-sync');
exports.InteractionsActionType = InteractionsActionType;
var ModalType = (0, _namespacedKeyMirror.default)({
  CONNECT_PROVIDER: null,
  DISCONNECT_PROVIDER_CONFIRMATION: null,
  PROVIDE_API_KEY: null
}, 'esp-sync-modals');
exports.ModalType = ModalType;
var closeModal = (0, _fluxActions.createAction)(InteractionsActionType.CLOSE_MODAL, (0, _actions.mapPayloadTo)('modal'));
exports.closeModal = closeModal;
var openModal = (0, _fluxActions.createAction)(InteractionsActionType.OPEN_MODAL, (0, _actions.mapPayloadTo)('modal'));
exports.openModal = openModal;